import { Routes, Route } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import Products from '../pages/Products';
import CoilsPage from '../pages/products/CoilsPage';
import SparkPlugsPage from '../pages/products/SparkPlugsPage';
import WiresPage from '../pages/products/WiresPage';
import SensorsPage from '../pages/products/SensorsPage';
import SteeringClocksPage from '../pages/products/SteeringClocksPage';
import ReceivePage from '../pages/ReceivePage';
import SalesPage from '../pages/SalesPage';
import ExpensesPage from '../pages/ExpensesPage';
import NotFound from '../pages/NotFound';
import Settings from '../pages/Settings';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Главная вложенная: используем index вместо абсолютного "/" */}
      <Route index element={<Dashboard />} />

      {/* Вложенный раздел products (относительный путь) */}
      <Route path="products" element={<Products />}>
        <Route path="coils" element={<CoilsPage />} />
        <Route path="plugs" element={<SparkPlugsPage />} />
        <Route path="wires" element={<WiresPage />} />
        <Route path="sensors" element={<SensorsPage />} />
        <Route path="clocks" element={<SteeringClocksPage />} />
      </Route>

      <Route path="receive" element={<ReceivePage />} />
      <Route path="sales" element={<SalesPage />} />
      <Route path="expenses" element={<ExpensesPage />} />

      <Route path="settings" element={<Settings />} />

      {/* 404 внутри приватного layout */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
